/**
 * アコーディオン関連 Class
 */
export default class Accordion {
  constructor() {
    this.spNavigation();
    this.anchorLink();
  };

  /**
   * スマホナビゲーション アコーディオン
   */
  spNavigation() {
    $(document).on('click', 'span.l-header__nav--sp-link', function () {
      const $parent = $(this).parent();
      const $child = $(this).next();
      if ($parent.hasClass('is-open')) {
        $parent.removeClass('is-open');
        $child.slideUp();
      } else {
        $('.l-header__nav--sp-item').removeClass('is-open');
        $('.l-header__nav--sp-child').slideUp();
        $parent.addClass('is-open');
        $child.slideDown();
      }
    });
  };

  /**
   * アンカーリンク アコーディオン
   */
  anchorLink() {
    $(document).on('click', '#js-anchor-accordion .c-anchor-nav__accordion-label', function () {
      const $parent = $(this).parent();
      const $child = $(this).next();
      if ($parent.hasClass('is-open')) {
        $parent.removeClass('is-open');
        $child.slideUp();
      } else {
        $parent.addClass('is-open');
        $child.slideDown();
      }
    });
  };
}
